import React from "react";

// reactstrap components
// import { Container, Row, Col } from "reactstrap";

// core components

function Images() {
  return (
    <>
      <div class="homecontent">
        <p>
          Intertek has made every attempt to ensure the accuracy and
          reliability of the information provided on this website. However, the
          information is provided "as is" without warranty of any kind. Intertek
          does not accept any responsibility or liability for the accuracy,
          content, completeness, legality, or reliability of the information
          contained on this website.
        </p>

        <p>
          No warranties, promises and/or representations of any kind, expressed
          or implied, are given as to the nature, standard, accuracy or
          otherwise of the information provided in this website nor to the
          suitability or otherwise of the information to your particular
          circumstances.
        </p>

        <p>
          We cannot and will not guarantee that this website is free from
          computer viruses or anything else that has destructive properties.
        </p>

        <p>
          We shall not be liable for any loss or damage of whatever nature
          (direct, indirect, consequential, or other) whether arising in
          contract, tort or otherwise, which may arise as a result of your use
          of (or inability to use) this website, or from your use of (or failure
          to use) the information on this site. This website provides links to
          other websites owned by third parties. The content of such third party
          sites is not within our control, and we cannot and will not take
          responsibility for the information or content thereon. Links to such
          third party sites are not to be taken as an endorsement by Intertek of
          the third party site, or any products promoted, offered or sold on the
          third party site, nor that such sites are free from computer viruses
          or anything else that has destructive properties. We cannot and do not
          take responsibility for the collection or use of personal data from
          any third party site. In addition, we will not accept responsibility
          for the accuracy of third party advertisements.
        </p>

        <p>
          INTERTEK and the Intertek logo are registered trademarks of Intertek
          Group plc.
        </p>

        <p>
          Intertek Group plc is a public limited company registered in England
          and Wales under Company Register Number 4267576 and with its
          registered office at 33 Cavendish Square, London, England W1G 0PS.
        </p>

        {/* <Container>
          <Row>
            <Col md="5">
              <div className="sw_home_img">
                <img
                  alt="..."
                  src={require("assets/img/dispensing_vector_small.png")}
                ></img>
              </div>
            </Col>
            <Col md="7">
              <div className="sw_home_content">
                <p>
                 This is Credit Management System home page. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>

                <p>
                 This is Credit Management System home page. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </div>
            </Col>
          </Row>
        </Container> */}
      </div>
    </>
  );
}

export default Images;
